import React, { useEffect } from 'react';
import Layout from '@/components/layout/Layout';
import Seo from '@/components/common/Seo';
import { useTranslation } from '@/hooks/useTranslation';

// Importiere alle Sektionen für die E-Commerce-Entwicklung
import HeaderSection from './HeaderSection';
import RequirementsSection from './RequirementsSection';
import DevelopmentSection from './DevelopmentSection';
import TechnologySection from './TechnologySection';
import ECommerceModelsSection from './ECommerceModelsSection';
import SEAMarketingSection from './SEAMarketingSection';
import FoundersSection from './FoundersSection';
import ProjectsSection from './ProjectsSection';
import ContactForm from '@/components/common/ContactForm';

// Registriere die Übersetzungen
import translations from './translations';
import { registerTranslations } from '@/hooks/useTranslation';

// Registriere die Übersetzungen für diese Seite
registerTranslations('shopwarePage', translations);

const ShopwarePage = () => {
  const { t } = useTranslation();
  
  // Scroll to top on page load
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Seo 
        title="E-Commerce Plattformen & Online-Shops | Shopware, B2B, B2C & SEA Marketing"
        description="Professionelle E-Commerce Lösungen: Shopware-Shops, B2B-Portale, Multi-Channel-Vertrieb mit Amazon/eBay und SEA-Marketing. Von der Entwicklung bis zur Optimierung."
        canonical="/shopware"
      />
      <Layout>
        <main>
          {/* E-Commerce-Entwicklung für den Mittelstand */}
          <HeaderSection />           {/* E-Commerce-Potenzial */}
          <RequirementsSection />     {/* Komplexe Anforderungen */}
          <DevelopmentSection />      {/* Professionelle Entwicklung */}
          <TechnologySection />       {/* Shopify vs. Shopware vs. Custom */}
          <ECommerceModelsSection />  {/* Verschiedene E-Commerce-Modelle */}
          <SEAMarketingSection />     {/* B2C-Marketing & Online-Werbung */}
          <FoundersSection />         {/* Entwickler-Expertise */}
          <ProjectsSection />         {/* Realisierte Projekte */}
          <ContactForm />             {/* Projektgespräch */}
        </main>
      </Layout>
    </>
  );
};

export default ShopwarePage; 